import React, { useState, useRef } from 'react';
import VideoPlayer from './VideoPlayer';
import TimeSelector from './TimeSelector';
import Recorder from './Recorder';
import PlaybackControls from './PlaybackControls';
import SongSelector from './SongSelector';
import './styles.css';  // Importation du CSS global

const App = () => {
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [startTime, setStartTime] = useState(0);
  const [segmentDuration, setSegmentDuration] = useState(5); // 5 secondes pour les tests
  const [audioURL, setAudioURL] = useState(null);
  const [recording, setRecording] = useState(false);
  const [loopCount, setLoopCount] = useState(1);
  const [videoDuration, setVideoDuration] = useState(0); // Durée de la vidéo en secondes
  const videoRef = useRef(null);
  const recorderRef = useRef(null);

  const handleSongSelect = (videoId) => {
    setSelectedVideoId(videoId);
    setStartTime(0);
    setSegmentDuration(5); // 5 secondes pour les tests
  };

  const handleURLSubmit = (url) => {
    const videoId = extractYouTubeID(url);
    if (videoId) {
      setSelectedVideoId(videoId);
      setStartTime(0);
      setSegmentDuration(5); // 5 secondes pour les tests
    } else {
      alert('URL YouTube invalide. Veuillez entrer une URL valide.');
    }
  };

  const extractYouTubeID = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const adjustSegmentDuration = (amount) => {
    setSegmentDuration(prevSegmentDuration => {
      const newSegmentDuration = Math.max(5, Math.min(prevSegmentDuration + amount, 30));
      return newSegmentDuration;
    });
  };

  const handleStopRecording = () => {
    if (recorderRef.current) {
      recorderRef.current.stopRecording();
    }
  };

  const handleTimeChange = ({ start, end }) => {
    setStartTime(start);
  };

  const handleVideoDuration = (duration) => {
    setVideoDuration(duration);
  };

  return (
    <>
      <div className="header">
        <div className="menu">
          <a href="https://www.bandeimprovisation.com/">Accueil</a>                
          <a href="https://www.bandeimprovisation.com/outils-pour-impro">Outils pour impro</a>
        </div>
      </div>
      <div className="container">
        <h1>Diction, projection, ton, accent…<br/>
Exerçons-nous !</h1>
        <SongSelector onSongSelect={handleSongSelect} onURLSubmit={handleURLSubmit} />
        {selectedVideoId && (
          <>
            <div className="video-container">
              <VideoPlayer videoId={selectedVideoId} startTime={startTime} endTime={startTime + segmentDuration} ref={videoRef} onDurationChange={handleVideoDuration} />
              <TimeSelector 
                duration={videoDuration} 
                startTime={startTime} 
                segmentDuration={segmentDuration} 
                onChange={handleTimeChange} 
              />
            </div>
            <div className="segment-controls">
            <button onClick={() => adjustSegmentDuration(5)}>+5s</button>
              <button onClick={() => adjustSegmentDuration(-5)}>-5s</button>
              <div>
                <label>Nombre de répétitions à pratiquer en boucle</label>
                <input type="number" min="1" value={loopCount} onChange={(e) => setLoopCount(Number(e.target.value))} />
              </div>
            </div>
            <Recorder 
              startTime={startTime} 
              endTime={startTime + segmentDuration} 
              onRecordingComplete={setAudioURL} 
              videoRef={videoRef}
              ref={recorderRef}
              setRecording={setRecording}
              loopCount={loopCount}
            />
            {recording && <button onClick={handleStopRecording}>Arrêter l'enregistrement</button>}
            {audioURL && 
              <PlaybackControls 
                videoId={selectedVideoId} 
                audioURL={audioURL} 
                videoRef={videoRef} 
                startTime={startTime}
                endTime={startTime + segmentDuration}
                loopCount={loopCount}
              />}
          </>
        )}
      </div>
     
    </>
  );
};

export default App;
